import React, { useState } from "react";
import styles from "./SendPasswordResetForm.scss";
import cx from "../utils/cx";
import TextField from "./MaterialUi/TextField";
import Button from "./MaterialUi/Button";
import RequestManager from "../utils/RequestManager";
import useUser from "../stores/useUser";
import History from '../utils/BrowserHistory';
import Error from "./Error";
import PasswordField from "./MaterialUi/PasswordField";
import createToast from "./MaterialUi/Toast";

export interface ISendPasswordResetFormProps {
  className?: string;
  resetToken: string;
  name: string;
}

const SendPasswordResetForm: React.FC<React.PropsWithChildren<ISendPasswordResetFormProps>> = ({ className = '', resetToken, name }) => {

    const [isLoading, setIsLoading] = useState(false);
    const [newPassword, setNewPassword] = useState('');
    const [error, setError] = React.useState(null);

    const [, userActions] = useUser();


    const handleSubmit = (ev) => {
        ev.preventDefault();

        if (!newPassword) {
            createToast('Bitte geben Sie ein korrektes, neues Passwort ein.', 'error');
            return;
        }

        setIsLoading(true);
        RequestManager.postRequest('/user/lost-password-reset?_format=json', {},
            {
                "name": name,
                "temp_pass": resetToken,
                "new_pass": newPassword
            }).then((response) => {
            userActions.login(name, newPassword).then((user) => {
                location.assign(`/user/${user.uid}`);
            }).catch((e) => {
                console.error(e);
            });

            setIsLoading(false);
        }).catch((e) => {
            console.error(e);
            setError("Fehler beim Setzen des Passwortes. " + (e?.responseData?.message || '') + ' Möglicherweise ist der Link abgelaufen.');
            setIsLoading(false);
            History.push({ pathname: '/user/login', search: '' });
        });
    }

    const handleChange = (value) => {
        setNewPassword(value);
    }

    const isValid = !!newPassword;

    return <div className={cx(styles.sendPasswordResetForm, className)}>
        {error && <Error className="error">{error}</Error>}
        {error && <p><a href="/user/login">Zurück zum Login</a></p>}
        {!error &&
        <form onSubmit={handleSubmit}>
            <p>Neues Passwort für: {name}</p>
            <PasswordField label="Neues Passwort" name="newPassword" value={newPassword} onChange={handleChange} />
            <Button loading={isLoading} type="submit" visualDisabled={!isValid}>Speichern</Button>
        </form>
        }
    </div>
};

export default SendPasswordResetForm;
